// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { DesignStudioWeddingRingNewCustomerResponseFragmentDoc } from '../fragments/designStudioWeddingRingNewCustomerResponse.fragment.generated';
import { DesignStudioWeddingRingSuccessNewCustomerFragmentDoc } from '../fragments/success/designStudioWeddingRingSuccessNewCustomer.fragment.generated';
import { CustomerRegistrationResponseFragmentDoc } from '../../../auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../../fragments/costumerConsultant.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerDocument = `
    mutation createDesignStudioProductAndAddToCartWeddingRingNewCustomer($input: DesignStudioWeddingRingInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createDesignStudioProductAndAddToCartWeddingRingNewCustomer(
    input: $input
    customer: $customer
  ) {
    ...designStudioWeddingRingNewCustomerResponse
  }
}
    ${DesignStudioWeddingRingNewCustomerResponseFragmentDoc}
${DesignStudioWeddingRingSuccessNewCustomerFragmentDoc}
${CustomerRegistrationResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}`;

export function useCreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation, SchemaTypes.CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutationVariables>(CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerDocument);
};